<template>
  <transition name="fade">
    <component
      :is="layout"
      v-if="fetched">
      <router-view v-slot="{ Component }">
        <transition name="switch" mode="out-in">
          <component :is="Component" :key="$route.fullPath" />
        </transition>
      </router-view>
    </component>
  </transition>
</template>

<script>
import axios from 'axios';
import FormUtils from './utils/FormUtils.js';
import SanitizeUtils from './utils/SanitizeUtils.js';
import { mapGetters } from 'vuex';

export default {
  data () {
    return {
      fetched: false
    }
  },
  computed: {
    layout () {
      if (!this.$route.meta) {
        return 'default-layout';
      }

      return `${this.$route.meta.layout || 'default'}-layout`;
    },
    ...mapGetters('user', ['isLoggedIn'])
  },
   // DODANA SEKCJA CREATED
  created() {
    // To żądanie jest wykonywane raz, gdy aplikacja startuje.
    // Jego jedynym celem jest pobranie i ustawienie ciasteczka XSRF-TOKEN,
    // które axios będzie automatycznie odczytywał i wysyłał w nagłówku X-XSRF-TOKEN.
    axios.get('/sanctum/csrf-cookie').catch(error => {
      console.error('Nie udało się pobrać tokenu CSRF. Błędy logowania i formularzy są spodziewane.', error);
    });
  },
  mounted () {
    this.fetched = true;
    window.crmApp = {};
    this.autoRefreshToken();
  },
  methods: {
    refreshToken () {
      FormUtils.submitInBackground(this, {
        endpoint: '/auth/refresh-token',
        errorTitle: 'An error occurred',
        errorText: 'An error occurred during refreshing API access. Please reload the page.',
        successAction: (data) => {
          window.localStorage.setItem('token', data.access_token);
          window.localStorage.setItem('last-token-refresh', +new Date());
          this.$http.defaults.headers.Authorization = 'Bearer ' + SanitizeUtils.getToken();
        }
      });
    },
    autoRefreshToken () {
      setTimeout(() => {
        if (this.isLoggedIn && window.localStorage.getItem('token')) {
          let lastRefresh = parseInt(window.localStorage.getItem('last-token-refresh'), 10);

          if (+new Date() - lastRefresh > 30 * 60 * 1000) {
            this.refreshToken();
          }
        }

        this.autoRefreshToken();
      }, 1 * 60 * 1000);
    }
  }
};
</script>

<style lang="scss">
@import './assets/scss/custom-elements.scss';

.switch-enter-active,
.switch-leave-active {
  transition: opacity .25s ease-out;
}

.switch-enter-from,
.switch-leave-to {
  opacity: 0;
}

.switch-enter-to,
.switch-leave-from {
  opacity: 1;
}
</style>
